import { createPartner, getNextPartnerCode, getPartnerCodeAvailability } from '../../../../api/partner/partner';
import { CreatedPartner, PartnerCreateRequest } from '../../../../api/partner/partnerApiTypes';
import { Edit } from './partnerCreateFormState';

function mapRequest(edit: Edit): PartnerCreateRequest {
  return {
    code: edit.code,
    partnerName: edit.partnerName,
    integration: edit.integration,
  };
}

export async function fetchNextPartnerCode(signal?: AbortSignal): Promise<string> {
  const nextPartnerCode = await getNextPartnerCode(signal);

  return nextPartnerCode.code;
}

export async function checkCodeAvailability(
  code: string,
  signal?: AbortSignal,
): Promise<boolean> {
  const availability = await getPartnerCodeAvailability(code, signal);

  return availability.available;
}

export async function createNewPartner(
  edit: Edit,
  signal?: AbortSignal,
): Promise<CreatedPartner> {
  return createPartner(mapRequest(edit), signal);
}
